import * as yup from "yup";

export const validationLoginForm = yup.object().shape({
  login: yup.string().required("Это поле обязательное!"),
  password: yup.string().required("Это поле обязательное!"),
});
